import angular from 'angular';
import CheckboxComponent from './checkbox.component';

const checkbox = angular
	.module('frCheckbox', [])
	.component('frCheckbox', CheckboxComponent)
	.name;

export default checkbox;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/checkbox/checkbox.module.js